import { render } from "./Grayscale.vue?vue&type=template&id=5742c0cf"
import script from "./Grayscale.vue?vue&type=script&lang=js"
export * from "./Grayscale.vue?vue&type=script&lang=js"

import "./Grayscale.vue?vue&type=style&index=0&id=5742c0cf&lang=css"

import exportComponent from "/home/mathias/PhpstormProjects/clone/vue3-color/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__